import { render, staticRenderFns } from "./TopMemberInfo.vue?vue&type=template&id=8cc10e16&scoped=true&"
import script from "./TopMemberInfo.vue?vue&type=script&lang=js&"
export * from "./TopMemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopMemberInfo.vue?vue&type=style&index=0&id=8cc10e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc10e16",
  null
  
)

export default component.exports